import { Component, DestroyRef,  EventEmitter, inject, Input, OnInit, Output, signal} from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';

import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { User } from '../dto/user';
import { AuthService } from '../service/auth.service';
import { Router } from '@angular/router';
import { FileService } from '../../../common/file/service/file.service';
import { environment } from '../../../../environments/environment';
import { LoginPoemService } from '../service/login-poem.service';
import { LoginPoem } from '../dto/login-poem';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { StateNotifyService } from '../../../common/state/service/state-notify.service';

@Component({
  selector: 'dpi-login',
  imports: [MatCardModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatButtonModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  @Input() form: FormGroup;
  @Input() title = '账号';
  @Input() subTitle = '';
  @Output() submitEvent = new EventEmitter<User>();
  //@Input() imgFromApi = '';
  imgFromApi = '';
  private token;
  poem!: LoginPoem;

  // 倒计时秒数，初始0
  countdown = signal(0);
  // 冷却时长
  private readonly COOL_SECONDS = 60;

  constructor(private formBuilder: FormBuilder, 
    private auth: AuthService, 
    private fileService: FileService, 
    private poemService: LoginPoemService, 
    private notifyService: StateNotifyService,
    private router: Router) {
    this.form = this.formBuilder.group({
      username: ['', Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(30)])],
      password: ['', Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(30)])],
      verificationCode: ['', Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(6)])]
    });
    this.token = environment.jwtToken;
  };

  ngOnInit(): void {
    localStorage.removeItem(this.token);
    this.notifyService.updateLoginState(false);

    this.poem = this.poemService.getRandomPoem();
    this.imgFromApi = 'img/' + this.poem.image;
  };

  loadImage() {
        let filePath = this.poem.image;
        this.fileService.fileDownloadGeneral(filePath)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: (img: any) => {
            this.imgFromApi = this.fileService.arrayBufferToBase64(img);
          },
          error: (error: any) => {
            console.error('Error: ', error);
            this.imgFromApi = "favicon.ico";
          }
        });
  }

  submit({ value, valid }: FormGroup, ev: Event) {
    if (!valid) {
      return;
    }
    const { username, password, verificationCode } = this.form.value;
    this.auth.login(username, password, verificationCode)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(
      res => {
        if (res) {
          this.router.navigate(['customers']);
          console.log(localStorage.getItem('JWT_Token'));
        }
      }
    );

  }

  imageClick() {
    this.poem = this.poemService.getNextPoem(this.poem);
    this.imgFromApi = 'img/' + this.poem.image;
    //this.loadImage();
    console.log('imageClick: ' + this.poem.image);
  }

  requireVerificationCode() {
    const { username, password, verificationCode } = this.form.value;
    this.auth.requireVerificationCode(username, password, '0')
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(
      res => {
        if (res) {
          this.startCountdown();
        }
      }
    );
  }

  private startCountdown(): void {
    this.countdown.set(this.COOL_SECONDS);
    const timer = setInterval(() => {
      this.countdown.update(val => {
        if (val <= 1) {
          clearInterval(timer);
          return 0;
        }
        return val - 1;
      });
    }, 1000);

    // 组件销毁时清除定时器，防止内存泄漏
    this.destroyRef.onDestroy(() => clearInterval(timer));
  }
}
